// extracted by mini-css-extract-plugin
export var actions = "_q7-4";
export var item = "_q7-1";
export var price = "_q7-3";
export var quantity = "_q7-2";
export var table = "_q7-0";